import { post } from '../utils/request2';

const Rike = {};

Rike.getArticleDetail = (params) => {
    return post('rike/get_rike_detail_h5', params);
};
Rike.getArticleDetailTest = (params) => {
    return post('rike/get_rike_detail_h5_test', params);
};
Rike.checkRegister = (params) => {
    return post('user/check_user_by_wxcode', params);
};

Rike.createOrder = (params) => {
    return post('rike/create_order_fs_h5', params);
};

Rike.getOrderStatus = (params) => {
    return post('rike/get_order_status_h5', params);
};
/* 日刻服务商专属二维码的价格列表 */
Rike.getSharePriceList = (params) => {
    return post('rike/get_order_settings_h5', params);
};
/* 日刻服务商专属二维码购买 */
Rike.createOrderAgent = (params) => {
    return post('rike/create_order_think_h5', params);
};
/* 日刻邀请别人注册 */
Rike.getWxOpenId = (params) => {
    return post('share/get_wx_union', params);
};

export default Rike;